import { useState } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNavigate } from "react-router-dom";
import { LoginRequestSchema, type LoginRequest } from "@opus-dt/shared-types";
import { useLogin } from "@/features/auth/hooks";
import { ApiClientError, getFriendlyErrorMessage } from "@/lib/api-client";
import { toast } from "@/components/ui/notify";
import { LoginStage } from "./LoginStage";
import { LoginPanel } from "./LoginPanel";
import "./login.css";

export function Login() {
  const navigate = useNavigate();
  const login = useLogin();
  const [needsTotp, setNeedsTotp] = useState(false);

  const form = useForm<LoginRequest>({
    resolver: zodResolver(LoginRequestSchema),
    defaultValues: { email: "", password: "", keepLoggedIn: false },
  });

  async function onSubmit(values: LoginRequest) {
    try {
      await login.mutateAsync(values);
      toast.success("Sessão iniciada.");
      navigate("/", { replace: true });
    } catch (err) {
      if (
        err instanceof ApiClientError &&
        err.error.code === "VALIDATION_ERROR" &&
        err.error.fields?.totpCode
      ) {
        setNeedsTotp(true);
        toast.error("Código TOTP obrigatório.");
        return;
      }
      toast.error("Não foi possível entrar.", { description: getFriendlyErrorMessage(err) });
    }
  }

  return (
    <div className="login-root">
      <LoginStage />
      <LoginPanel
        form={form}
        onSubmit={onSubmit}
        isPending={login.isPending}
        needsTotp={needsTotp}
      />
    </div>
  );
}
